
import React, { useState, useEffect } from 'react';
import UID_Auth_Time from './UID_Auth_Time';


const UID_Auth_Interface = ({ heading }) => {
    const [renderContent, setRenderContent] = useState(null);
    const [loadingAuthperson, setloadingAuthperson] = useState(true);
    const [loadingDate, setLoadingDate] = useState(true);
  //todays date 
 const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); 
    const day = String(today.getDate()).padStart(2, "0"); 
    return `${year}-${month}-${day}`;
  };
  getTodayDate();

  const [selectedDate, setSelectedDate] = useState(getTodayDate());

    useEffect(() => {
        if (!loadingAuthperson && !loadingDate) {
            const timer = setTimeout(() => {
                handleSubmit();
            }, 10);
            return () => clearTimeout(timer);
        }
    }, [loadingAuthperson, loadingDate]);

    const handleDateLoadingChange = (isLoading) => {
        setLoadingDate(isLoading);
    };

    const formatDateString = (dateString) => {
        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
    };
    const handleChange = (event) => {
        setSelectedDate(event.target.value);   
      };
    
    const handleSubmit = () => {
        const auth_person = document.getElementById('auth_person').value;
console.log(auth_person);
        if (!auth_person || auth_person === '0') {
            alert('Please Select Auth Person');
        } else if (!selectedDate || selectedDate === '0' || selectedDate === '' || selectedDate == null) {
            alert('Please select Date');
        } else {
            setRenderContent(null);

            setTimeout(() => {
                setRenderContent(
                    <UID_Auth_Time
                        auth_person={auth_person}
                        trans_date={formatDateString(selectedDate)}
                        heading={heading}
                    />
                );
            }, 0);
        }
    };

    return (
        <div className="wrapper row3">
            <div id="container">
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <table width="50%">
                        <thead>
                            <tr className="tableheader">
                                <th colSpan={8}>{heading}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Auth Person </td>
                                <td>
                                    <select id="auth_person">
                                        <option value="">-Select-</option>
                                        <option value="D">Dealer</option>
                                        <option value="B">Beneficiary</option>
                                    </select>
                                </td>
                                <td>Date</td>
                                <td>
                                <input type="date"   name="trans_date" 
                                     id="trans_date" value = {selectedDate} onChange={handleChange}/> 
                                    
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={8} align="center">
                                    <button
                                        onClick={handleSubmit}
                                        className="button button2" >
                                        Submit
                                    </button>
                                    <button className="button button2">Back</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br></br><br></br>
                <div id="detailsER">{renderContent}</div>
            </div>
        </div>
    );
};

export default UID_Auth_Interface;


